module.exports = {
  SHRED_CARD: 10,
};
